<ng-template #joinTmpl>
  <div class="join-container" *ngIf="channel.publicity === 'public'">
    <h3>{{ 'map.tools.chatDrawer.notJoinedMessage' | t }}</h3>
    <button mat-button color="success" (click)="join()">{{ 'map.tools.chatDrawer.joinChannel' | t }}</button>
  </div>
  <div class="join-container" *ngIf="!userHasAccess && channel.publicity === 'private'">
    <h3>{{ 'map.tools.chatDrawer.noAccess' | t }}</h3>
  </div>
</ng-template>

<ng-container *ngIf="userHasAccess; else joinTmpl">
  <sn-message-list
    *ngIf="channel.twilioChannel"
    ngFileDrop
    [channel]="channel"
    [options]="uploaderOptions"
    (uploadOutput)="onUploadOutput($event)"
  >
  </sn-message-list>

  <sn-new-message class="mt-auto" [channel]="channel"></sn-new-message>
</ng-container>
